import { createSelector } from 'reselect'
import { selectProductName } from './product'
import { selectInsuranceCompanies } from './general'
import { selectQuoteRestrictions } from './quote'
import { getValidCalculatorsForProductName } from '../Core/FilterFunctions'
import { selectVehicleType } from './userData'

export const selectEnabledCalculators = createSelector(
  [selectInsuranceCompanies, selectProductName, selectQuoteRestrictions, () => false],
  getValidCalculatorsForProductName,
)

export const selectPatchedEnabledCalculators = createSelector(
  [selectEnabledCalculators, selectVehicleType],
  temporaryDisabledSlavieExceptVehicleCar,
)

// This logic was in submit handler on K1
// FIXME temporary solution due to SU-748/SU-729
function temporaryDisabledSlavieExceptVehicleCar(enabledCalculators: string[], vehicleType = '') {
  return vehicleType.toLowerCase() === 'car'
    ? enabledCalculators
    : enabledCalculators.filter((calculator) => !calculator.toLowerCase().includes('slavia') && !calculator.toLowerCase().includes('suri'))
}
